import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHelpCenter = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M8.99988 12.7501C8.65488 12.7501 8.37489 13.0301 8.37489 13.3751C8.37489 13.7201 8.65488 14.0001 8.99988 14.0001C9.34488 14.0001 9.62487 13.7201 9.62487 13.3751C9.62487 13.0301 9.34488 12.7501 8.99988 12.7501Z",
			fill: "white",
			fillOpacity: .74
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3032 3.6968C11.3741 0.767725 6.62522 0.767725 3.69677 3.69685C0.767725 6.6259 0.767725 11.3748 3.69688 14.3032C6.62522 17.2323 11.3741 17.2323 14.3032 14.3032C17.2323 11.3748 17.2323 6.6259 14.3032 3.6968ZM13.4194 13.4193C10.9784 15.8602 7.02105 15.8602 4.58077 13.4194C2.13981 10.979 2.13981 7.02161 4.58071 4.58071C7.02105 2.13978 10.9784 2.13978 13.4193 4.58071C15.8602 7.02164 15.8602 10.979 13.4194 13.4193Z",
			fill: "white",
			fillOpacity: .74
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.4481 4.03957C7.89463 3.76687 6.49989 4.94962 6.49989 6.50012C6.49989 6.8453 6.77971 7.12511 7.12488 7.12511C7.47006 7.12511 7.74987 6.8453 7.74987 6.50012C7.74987 5.72355 8.44644 5.13284 9.23183 5.27071C9.72642 5.35766 10.1423 5.77359 10.2293 6.26833C10.326 6.81861 10.0686 7.33863 9.60188 7.59591C8.82911 8.02201 8.37486 8.87458 8.37486 9.78574V10.8751C8.37486 11.2203 8.65468 11.5001 8.99985 11.5001C9.34503 11.5001 9.62484 11.2203 9.62484 10.8751V9.78574C9.62484 9.31063 9.85116 8.88586 10.2054 8.69056C11.1342 8.17848 11.6507 7.13516 11.4604 6.052C11.2824 5.03915 10.4609 4.21761 9.4481 4.03957Z",
			fill: "white",
			fillOpacity: .74
		})
	]
});
const ForwardRef = forwardRef(SvgHelpCenter);
export { ForwardRef as ReactComponent };
